import React, { Component } from "react";
import close_btn from '../../../images/close_btn.svg';
class GrandParentConfirm extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
    }
    render() {
        let { title, grandparentsList, toggle_gp_popup, save_loader, submit_msg, handleAddGrandParent } = this.props;
        return (
            <div className="add_url_pop proceedgp_pop">

                <div>
                    <div className="header">
                        {title}
                        <div className="close" onClick={toggle_gp_popup}>
                            <img src={close_btn} alt="" />
                        </div>
                    </div>

                    <div className="body">
                        <div className="overidebox">
                            <p>Please note the following distributor will be added as a Grandparent to the selected group number.</p>
                            <div className="override_body">
                                {typeof grandparentsList === 'object' ?
                                    <div className="over_ride_table">
                                        <div className="theader">
                                            <div>User Name</div>
                                            <div>Full Name</div>
                                            <div>Commission($)</div>
                                            <div>2nd Level</div>
                                        </div>
                                        <div className="tbody_parent">
                                            {grandparentsList.map((row, index) =>
                                                <div className='table_body' key={index}>
                                                    <div>
                                                        {row.parent_UserName}
                                                    </div>
                                                    <div>
                                                        {row.parent_FullName}
                                                    </div>
                                                    <div>
                                                        {row.parent_GcComm}
                                                    </div>
                                                    <div>
                                                        {row.parent_IsAllowedForGC ? <span className="greenTag">Yes</span> : <span className="orangeTag">No</span>}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div> : null}
                            </div>
                        </div>
                    </div>
                    <div className="footer">
                        <div className={save_loader ? 'yes_btn loader' : 'yes_btn'}
                            onClick={handleAddGrandParent}
                        >Proceed</div>
                        <div className="no_btn" onClick={toggle_gp_popup}>Cancel</div>
                        {submit_msg?.length ?
                            <div className="error_submit_msg">{submit_msg}</div>
                            : null}
                    </div>
                </div>
            </div>
        )
    }
}
export default GrandParentConfirm;
